import React, { useContext } from "react"
import { ManifestPage as SharedManifestPage } from "@stjeans/shared-frontend/manifests"
import AppContext from "../../AppContext.jsx"
import api from "../../api.js"
import { formatManifestStatus, formatStatus, formatFishTag, isOverseas, lastNameCommaFirstName } from "../../helpers.js"
import getOriginalLocation from "../helpers/getOriginalLocation.js"

export default function ManifestPage() {
  const { app } = useContext(AppContext)

  return (
    <SharedManifestPage
      app={app}
      injectBootstrap={app?.connected === false}
      // @ts-ignore - lodge-only UI behavior
      disableManifestSendWhenOffline={app?.connected === false}
      // @ts-ignore - lodge-only UI behavior
      disableManifestWritesWhenOffline={app?.connected === false}
      api={{
        ...api,
        getManifest: async (manifestId) => {
          const res = await api.getManifest(manifestId)
          return res?.data ?? res
        },
      }}
      // @ts-ignore - shared frontend helpers typing is intentionally loose
      helpers={{ formatStatus, formatManifestStatus, getOriginalLocation, lastNameCommaFirstName, isOverseas, formatFishTag }}
      manifestDetailsFields={[
        { key: "depot", label: "Location" },
        { key: "createdDate", label: "Created Date" },
        { key: "closedDate", label: "Closed Date" },
        { key: "transferredDate", label: "Shipped Date" },
      ]}
      showAdditionalInformation={false}
      showLabelDescriptionEditing={false}
      showPrintLabelButton={false}
      showPrintManifestButton={false}
      enableLodgeStatusButtons={true}
      orderColumns={[
        { key: "master", label: "Master", sortable: true, preferredWidth: 110, cellType: "text", value: (o) => o.master, cellClassName: "fw-semibold", cellStyle: { color: "#0f6170" } },
        { key: "status", label: "Status", sortable: true, preferredWidth: 140, minWidth: 130, cellType: "status", value: (o) => o.status },
        { key: "firstName", label: "First Name", preferredWidth: 140, cellType: "text", value: (o) => o.firstName },
        { key: "lastName", label: "Last Name", preferredWidth: 160, cellType: "text", value: (o) => o.lastName },
        { key: "boxes", label: "Boxes", sortable: true, preferredWidth: 80, cellType: "text", value: (o) => String(o.boxes ?? "") },
        { key: "orderDate", label: "Order Date", sortable: true, preferredWidth: 110, cellType: "text", value: (o) => o.orderDate },
      ]}
      fetchOrdersCallback={({ manifestId, page, perPage, sortBy, sortDirection }) => {
        const filters = [`{manifest_id = ${String(manifestId)}}`]
        return api.getOrders(page, perPage, sortBy, sortDirection, "", filters)
      }}
    />
  )
}

